<script lang="ts" setup>
defineProps<{
  text: string;
}>();
</script>

<template>
  <p class="text-text-white leading-[120%] tracking-normal md:text-xl" v-html="text"></p>
</template>
